import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import labelKey from '../../../localization/label.json'

import { useUpdateExpenseToSpecificAPMutation } from '../../../../services/ExpenseApi';
import { KTSVG } from '../../../../_metronic/helpers';
type Props = {
    show: boolean
    handleClose: () => void
    data: any
    isChecked: boolean
    refetch?:any
}
const AssigntomeModal = ({ show, handleClose, data, isChecked,refetch }: Props) => {
    const [updateDepartmentLocationStatus, { isLoading, isSuccess, isError, error }] = useUpdateExpenseToSpecificAPMutation();
    const handleConfirmation = async () => {
        await updateDepartmentLocationStatus({ expenseId: data?.expenseId, isActive: !data?.assignedActive });
        handleClose();
    };

    useEffect(() => {
        if (isSuccess) {
            toast.success('Status Update Successfully');
            handleClose();
            refetch();
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);
    return (
        <>
            <Modal
                aria-hidden='true'
                dialogClassName='modal-dialog modal-md modal-dialog-centered'
                show={show}
                onHide={handleClose}
            >
                <div className='modal-header bg-light py-4'>
                    <h2 className='mb-0'>{isChecked === true ?<>{labelKey.assignToMe}</>:<>{labelKey.unAssign}</>}</h2>
                    {/* begin::Close */}
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                    </div>
                    {/* end::Close */}
                </div>
                <div className='modal-body py-lg-6 px-lg-6'>
                <p className='fs-5 fw-semibold'>Are you sure you want to <span>{isChecked === true ? 'Assign' : 'Unassign'}</span> yourself from this assignment?</p>
                </div>
                <div className='modal-footer justify-content-center py-4'>
                    <button className='btn btn-light' onClick={handleClose}>{labelKey.cancel}</button>
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn btn-primary'
                        onClick={handleConfirmation}
                        disabled={isLoading}
                    >
                        {!isLoading && <span className='indicator-label'>{labelKey.yes}</span>}
                        {isLoading && (
                            <span className='indicator-progress' style={{ display: 'block' }}>
                                {labelKey.pleaseWait}{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default AssigntomeModal